import "./StatusBadge.css";

function StatusBadge({ status }) {

    const getClassName = () => {

        switch (status) {

            case "Pending":
                return "badge pending";

            case "Accepted":
                return "badge accepted";

            case "Preparing":
                return "badge preparing";

            case "Ready":
                return "badge ready";

            case "Assigned":
                return "badge assigned";

            case "Picked Up":
                return "badge picked";

            case "Out For Delivery":
                return "badge delivery";

            case "Delivered":
                return "badge delivered";

            case "Cancelled":
                return "badge cancelled";

            case "Rejected":
                return "badge rejected";

            default:
                return "badge";
        }

    };

    return (

        <span className={getClassName()}>

            {status}

        </span>

    );

}

export default StatusBadge;